import { useMyInfoStore } from '@/store/modules/myinfo';

/**
 * 회원 상태 정보 접근용 composable.
 * `src/composables/` 하위라 auto-import 되어 import 없이 어디서든 사용 가능.
 *
 * @example
 *   const { isSmartwelMember, partner } = useMember();
 *   if (isSmartwelMember.value) console.log(partner.value.totalPoint);
 */
export default function useMember() {
  const myInfoStore = useMyInfoStore();
  const { partner, isSmartwelMember, myInfo } = storeToRefs(myInfoStore);

  return {
    myInfo,
    partner,
    isSmartwelMember,
  };
}
